import { Alert } from "antd"

export default function SelfPosition({ data }) {
  const { name, rank, totalObtainedMarks, quizMark, assignmentMark } = data || {}
  return (
    <div>
      <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>

      {
        totalObtainedMarks <= 0 ?

          <div>
            <Alert message={false} showIcon
              description="You have not received any marks yet! Please participate in quizzes or assignments"
              type="info" />
          </div>
          :

          <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
            <thead>
              <tr>
                <th className="table-th !text-center">Rank</th>
                <th className="table-th !text-center">Name</th>
                <th className="table-th !text-center">Quiz Mark</th>
                <th className="table-th !text-center">Assignment Mark</th>
                <th className="table-th !text-center">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr className="border-2 border-cyan">
                <td className="table-td text-center font-bold">{rank}</td>
                <td className="table-td text-center font-bold">{name}</td>
                <td className="table-td text-center font-bold">{quizMark}</td>
                <td className="table-td text-center font-bold">{assignmentMark}</td>
                <td className="table-td text-center font-bold">{totalObtainedMarks}</td>
              </tr>
            </tbody>
          </table>
      }
    </div>
  )
}